import type { Product } from "@/features/inventory/types";
import type { components } from "@/types/api";

/** Catalogue avancé (ADR 0058) — types générés depuis l'OpenAPI (`pnpm gen:types`). */
type Schemas = components["schemas"];

export type CatalogImportPreview = Schemas["CatalogImportPreview"];
export type CatalogImportResult = Schemas["CatalogImportResult"];
export type CatalogImportLine = Schemas["CatalogImportLine"];
export type CatalogImportAction = Schemas["ActionEnum"];
export type MissingVariants = Schemas["MissingVariants"];
export type GenerateVariantsResult = Schemas["GenerateVariantsResult"];

/** Résultat d'un scan : le produit suit le contrat de la liste des produits. */
export type ProductScanResult = Omit<Schemas["ProductScanResult"], "product"> & {
  product: Product | null;
};

export const IMPORT_ACTION_LABELS: Record<CatalogImportAction, string> = {
  create: "Créé",
  update: "Mis à jour",
  unchanged: "Inchangé",
  error: "En erreur",
};

/** État de stock filtrable : rupture, sous le seuil, au-dessus du seuil. */
export type StockState = "out" | "low" | "available";

export const STOCK_STATE_LABELS: Record<StockState, string> = {
  out: "Rupture",
  low: "Stock bas",
  available: "Disponible",
};

/** Photo choisie dans le formulaire, posée après l'enregistrement du produit. */
export interface PhotoChange {
  file: File | null;
  remove: boolean;
}

export const NO_PHOTO_CHANGE: PhotoChange = { file: null, remove: false };

/** Affichage de la liste des produits. */
export type CatalogView = "list" | "cards";
